import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projectsData } from '../data/projects';

function ProjectDetail() {
  const { id } = useParams();
  const project = projectsData.find((item) => String(item.id) === id);

  if (!project) {
    return (
      <div className="container mx-auto py-16 sm:py-20">
        <div className="glass-panel rounded-3xl p-8 text-center">
          <p className="font-general-semibold text-2xl text-slate-900 dark:text-slate-100">Project not found</p>
          <p className="mt-2 text-slate-600 dark:text-slate-300">The requested project does not exist.</p>
          <Link
            to="/projects"
            className="mt-5 inline-flex rounded-xl bg-teal-700 px-5 py-2.5 text-white hover:bg-teal-600"
          >
            Back to Projects
          </Link>
        </div>
      </div>
    );
  }

  return (
    <motion.section
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      className="container mx-auto py-10 sm:py-14"
    >
      <div className="glass-panel rounded-3xl overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-5 sm:p-8">
          <div className="rounded-2xl overflow-hidden border border-slate-300/40 dark:border-slate-500/40">
            <img src={project.img} alt={project.title} className="h-full w-full object-cover" />
          </div>
          <div>
            <p className="font-general-medium text-xs uppercase tracking-[0.2em] text-teal-700 dark:text-teal-300">
              {project.category}
            </p>
            <h1 className="mt-3 font-general-semibold text-3xl sm:text-4xl section-title">{project.title}</h1>
            <p className="mt-4 text-slate-700 dark:text-slate-300 leading-relaxed">{project.summary}</p>

            <div className="mt-5">
              <p className="font-general-medium text-sm text-slate-900 dark:text-slate-100">Outcome</p>
              <p className="mt-1 text-slate-700 dark:text-slate-300">{project.outcome}</p>
            </div>

            <div className="mt-5 flex flex-wrap gap-2">
              {project.stack.map((item) => (
                <span
                  key={`${project.id}-${item}`}
                  className="rounded-full border border-slate-300/50 dark:border-slate-500/50 px-3 py-1 text-sm text-slate-700 dark:text-slate-200"
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="mt-6 flex gap-3">
              <a
                href={project.liveLink && project.liveLink !== '#' ? project.liveLink : 'https://github.com/kangzy-fix'}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex rounded-xl bg-teal-700 px-5 py-2.5 text-white hover:bg-teal-600"
              >
                Visit Live Project
              </a>
              <Link
                to="/projects"
                className="inline-flex rounded-xl border border-slate-300/50 dark:border-slate-500/60 px-5 py-2.5 text-slate-800 dark:text-slate-100"
              >
                All Projects
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}

export default ProjectDetail;